import React, { useEffect, useState } from "react";
import LoadingSpinner from "./LoadingSpinner";
import "../styles/GlobalLoadingOverlay.css";

const GlobalLoadingOverlay = () => {
  const [activeRequests, setActiveRequests] = useState(0);

  useEffect(() => {
    const handleChange = (event) => {
      setActiveRequests(Math.max(0, Number(event.detail?.activeRequests) || 0));
    };

    window.addEventListener("global-loading-change", handleChange);
    return () => window.removeEventListener("global-loading-change", handleChange);
  }, []);

  if (activeRequests <= 0) return null;

  return (
    <div className="global-loading-overlay" role="alert" aria-live="assertive">
      <div className="global-loading-overlay__dialog" aria-modal="true">
        <LoadingSpinner size="lg" label="Loading..." />
      </div>
    </div>
  );
};

export default GlobalLoadingOverlay;
